var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "vertical-menu" } },
    _vm._l(_vm.arr, function(item, index) {
      return !item.isChildren
        ? _c(
            "el-menu-item",
            {
              key: item.router,
              staticStyle: { position: "relative" },
              attrs: {
                "popper-class": "activeClass",
                index: "/main/" + item.router
              },
              on: {
                click: function($event) {
                  return _vm.itemChick(item)
                }
              }
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isCollapse,
                        expression: "!isCollapse"
                      }
                    ],
                    staticStyle: {
                      display: "inline-block",
                      "text-align": "left",
                      width: "144px",
                      "margin-left": "10%",
                      "font-weight": "bold"
                    },
                    attrs: { slot: "title" },
                    slot: "title"
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-arrow-right",
                staticStyle: {
                  color: "#525252",
                  display: "inline-block",
                  "text-align": "right",
                  position: "absolute",
                  right: "5%"
                }
              })
            ]
          )
        : _c(
            "el-submenu",
            {
              key: item.router,
              attrs: { index: "/main/" + item.router },
              nativeOn: {
                click: function($event) {
                  return _vm.itemChick(item)
                }
              }
            },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isCollapse,
                        expression: "!isCollapse"
                      }
                    ],
                    staticStyle: {
                      display: "inline-block",
                      "text-align": "left",
                      width: "144px",
                      "margin-left": "10%",
                      "font-weight": "bold"
                    },
                    on: {
                      click: function($event) {
                        return _vm.goItem(item.router)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-menu-item-group",
                [
                  _c("vertical-menu-item", {
                    attrs: {
                      arr: item.children,
                      "show-icon": true,
                      idx: _vm.idx + 1
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }